import { useState, useEffect, useCallback } from 'react';
import { supabase } from '@/integrations/supabase/client';
import { User } from '@supabase/supabase-js';

export function useSimulationLimits() {
  const [user, setUser] = useState<User | null>(null);
  
  useEffect(() => {
    supabase.auth.getUser().then(({ data }) => setUser(data.user));
  }, []);
  const [canSimulate, setCanSimulate] = useState(true);
  const [remaining, setRemaining] = useState(3);
  const [isLoading, setIsLoading] = useState(true);

  const checkLimit = useCallback(async () => {
    if (!user) {
      setCanSimulate(false);
      setRemaining(0);
      setIsLoading(false);
      return;
    }

    try {
      const { data, error } = await supabase.rpc('check_simulation_limit', {
        p_user_id: user.id
      });

      if (error) {
        console.error('Error checking simulation limit:', error);
        return;
      }

      const result = data?.[0];
      setCanSimulate(result?.can_simulate ?? false);
      setRemaining(result?.simulations_remaining ?? 0);
    } catch (error) {
      console.error('Error checking simulation limit:', error);
    } finally {
      setIsLoading(false);
    }
  }, [user]);

  useEffect(() => {
    checkLimit();
  }, [checkLimit]);

  return {
    canSimulate,
    remaining,
    isLoading,
    refreshLimit: checkLimit,
  };
}
